import React from 'react';
import { CardDeck, Container, Image } from 'react-bootstrap';
import HomeCard from '../components/HomeCard';
import logo from '../logo.png';
function Games() {
    return <Container>
        <h2>Games</h2>
        <Container className="p-3">
            <CardDeck>
                <HomeCard />
                <HomeCard />
                <HomeCard />
            </CardDeck>
        </Container>

    </Container>;

}


export default Games;